import React from 'react';
import styled from 'styled-components';
import {getLocale} from '@epic-core/common';

export const SubnavNumber = styled.span<{big?: boolean; colorOverride?: string}>`
    &.loc-en-US {
        font-family: ${(p) => p.theme.fonts.fira.medium};
    }
    font-weight: ${(p) => (p.big ? '700' : '500')};
    font-size: ${(p) => (p.big ? '15px' : '13px')};
    line-height: ${(p) => (p.big ? '20px' : '18px')};
    letter-spacing: ${(p) => (p.big ? '4px' : '3px')};
    padding: 0 ${(p) => `${p.theme.spacing(1)}px`} 0 0;

    ${(p) =>
        p.colorOverride ? `color: ${p.colorOverride}` : `color: ${p.theme.palette.text.secondary}`};
`;

export interface SubnavItemNumberProps {
    big?: boolean;
    index?: number | null | string | 'undefined';
    colorOverride?: string;
}

export const SubnavItemNumber = ({
    big,
    index = 0,
    colorOverride
}: SubnavItemNumberProps): JSX.Element | null => {
    if (typeof index === 'undefined' || index === null || index === 'undefined') return null;
    const indexNumber = +index; //it is possible that the CMS overrides the index to some string
    if (indexNumber === NaN) return null;

    return (
        <SubnavNumber
            big={big}
            className={`item-number loc-${getLocale()}`}
            colorOverride={colorOverride}>{`${indexNumber < 10 ? '0' : ''}${indexNumber + 1}`}</SubnavNumber>
    );
};
